import { FeatureFlagDictionary } from '../@types';
import { createGetEndpoint, HttpHeader } from '@sonar-software/sonar-http';

export type GetCustomerFeatureFlagsRequest = {
	customerId?: number;
	shardName?: string;
};

export type GetCustomerFeatureFlagsResponse = FeatureFlagDictionary;

export const getCustomerFeatureFlags = createGetEndpoint<
	GetCustomerFeatureFlagsRequest,
	GetCustomerFeatureFlagsResponse
>((request) => `/api/v3/core/customers/${request?.customerId ?? 'current'}/feature-flags`, {
	headers: (request) => {
		if (request?.shardName) {
			return { [ HttpHeader.Shard ]: request.shardName };
		}

		return {};
	}
});
